<template>
  <div class="container mt-1 border rounded midtxt">
    <div class="row" v-if="!expand_list">
      <div class="col fw-bold">Pools</div>
      <div class="col">
        <i
          class="bi bi-chevron-double-down float-end"
          @click="toggleExpand()"
        ></i>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col">
        <i
          class="bi bi-plus-lg float-start text-success"
          v-if="!local_action"
          @click="setLocalAction('newpool')"
        ></i>
        <i
          v-else
          class="bi bi-x-lg float-start text-danger"
          @click="setLocalAction('')"
        ></i>
        <div v-if="local_action == 'newpool'">
          <NewPool
            @pool-added="setLocalAction('')"
            class="border border-danger"
          ></NewPool>
        </div>
        <div v-if="!local_action">
          <i
            class="bi bi-chevron-double-up text-danger float-end"
            @click="toggleExpand()"
          ></i>
          <PoolList></PoolList>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import NewPool from "../pools/NewPool.vue";
import PoolList from "../pools/PoolList.vue";
import { ref } from "vue";
const local_action = ref("");
const expand_list = ref(false);
const toggleExpand = () => {
  expand_list.value = !expand_list.value;
};
const setLocalAction = (str) => {
  if (local_action.value != str) {
    local_action.value = str;
  } else {
    local_action.value = "";
  }
};
</script>
<style scoped>
.midtxt {
  font-size: 12px;
}
</style>
